/**
 * @fileoverview Module for `src/pledge-to-vote/PledgeToVote.js`.
 */

import { Component } from 'react';

import EnterCode from './EnterCode';
import MakePledge from './MakePledge';
import PledgeConfirmation from './PledgeConfirmation';

/**
 * Stateful container for the full pledge-to-vote flow.
 */
class PledgeToVote extends Component {
  /**
   * Initializes pledge status, voter context, and code state.
   *
   * @param {Object} props - Component props.
   */
  constructor(props) {
    super(props);
    this.state = {
      pledgeStatus: '', // possible values '' and 'thanks'
      voterState: '',
      code: '',
      urlElectionInfo: '',
    };
  }

  /**
   * Advances the flow to the thank-you confirmation step.
   */
  handlePledgeThanks = () => {
    this.setState({ pledgeStatus: 'thanks' });
  };

  /**
   * Stores voter context from a validated pledge code lookup.
   *
   * @param {Object} payload - Voter state, code, and election URL.
   */
  handleVoterInfo = (payload) => {
    this.setState(payload);
  };

  /**
   * Renders the current pledge flow step: code entry, pledge action,
   * or confirmation.
   *
   * @returns {JSX.Element} The active pledge-to-vote step.
   */
  render() {
    return (
      <main className='bg-white py-5 mb-5'>
        {
          this.state.codeSubmitted
            ? null
            : <EnterCode handleVoterInfo={ this.handleVoterInfo } />
        }
        {
          this.state.codeSubmitted && this.state.pledgeStatus !== 'thanks'
            ? (
              <MakePledge
                code={ this.state.code }
                handlePledgeThanks={ this.handlePledgeThanks }
                urlElectionInfo={ this.state.urlElectionInfo }
                voterState={ this.state.voterState }
              />
              )
            : null
        }
        {
          this.state.pledgeStatus === 'thanks'
            ? <PledgeConfirmation urlElectionInfo={ this.state.urlElectionInfo } />
            : null
        }
      </main>
    );
  }
}

export default PledgeToVote;
